import { Subscription as RecurlySubscription } from "@recurly/react-recurly";
import {
	AccountSubscriptionPaidConfig,
	SUBSCRIPTION_CYCLE,
} from "~utils/types/__generated/gql/graphql";

export const getRecurlyPlan = (
	values: AccountSubscriptionPaidConfig,
): RecurlySubscription["plan"] => {
	const { plan: planFormValue, cycle } = values;

	let plan = planFormValue.toLowerCase();
	switch (cycle) {
		case SUBSCRIPTION_CYCLE.MONTHLY:
			plan += "";
			break;
		case SUBSCRIPTION_CYCLE.ANNUAL:
			plan += "_one_year";
			break;
		case SUBSCRIPTION_CYCLE.TWO_YEARS:
			plan += "_two_years";
			break;
		case SUBSCRIPTION_CYCLE.THREE_YEARS:
			plan += "_three_years";
			break;
		case SUBSCRIPTION_CYCLE.FOUR_YEARS:
			plan += "_four_years";
			break;
		case SUBSCRIPTION_CYCLE.FIVE_YEARS:
			plan += "_five_years";
			break;
	}

	return plan;
};
